import IconWrapper from "@components/svg_icon_wrapper"

export default function ConversationCardTelegram() {
  return (
    <IconWrapper sx={{ width: 14, height: 14 }}>
      <svg
        id="wa-whatsapp-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="512"
        height="512"
        viewBox="0 0 512 512"
      >
        <path
          id="Path_4965"
          data-name="Path 4965"
          d="M512,382.07c0,2.8-.09,8.88-.26,13.58-.41,11.49-1.32,26.32-2.7,33.07a109.76,109.76,0,0,1-9.27,27.71,98.45,98.45,0,0,1-43.43,43.39,110.209,110.209,0,0,1-27.87,9.28c-6.69,1.35-21.41,2.24-32.82,2.65-4.71.17-10.79.25-13.58.25H129.97c-2.8,0-8.88-.09-13.58-.26-11.49-.41-26.32-1.32-33.07-2.69a110.367,110.367,0,0,1-27.72-9.28A98.5,98.5,0,0,1,12.18,456.3,110.209,110.209,0,0,1,2.9,428.43C1.55,421.74.66,407,.25,395.61.08,390.91,0,384.82,0,382V129.9c0-2.8.09-8.88.25-13.58C.71,104.86,1.62,90,3,83.28a110.371,110.371,0,0,1,9.27-27.72A98.59,98.59,0,0,1,55.7,12.18,110.21,110.21,0,0,1,83.57,2.9C90.26,1.55,105,.66,116.39.25,121.09.08,127.18,0,130,0H382.1c2.8,0,8.88.09,13.58.25C407.14.71,422,1.62,428.72,3a110.37,110.37,0,0,1,27.72,9.27A98.59,98.59,0,0,1,499.82,55.7a110.207,110.207,0,0,1,9.28,27.87c1.35,6.69,2.24,21.41,2.65,32.82.17,4.7.25,10.79.25,13.58Z"
          fill="#3fb3df"
          fillRule="evenodd"
        />
        <path
          id="bxl-telegram"
          d="M308.864,7.219,18.314,119.255c-19.829,7.964-19.709,19.031-3.638,23.959l74.6,23.27L261.865,57.594c8.161-4.971,15.612-2.294,9.483,3.146L131.519,186.935h-.033l.033.022-5.146,76.89c7.538,0,10.87-3.463,15.087-7.538l36.227-35.233,75.372,55.663c13.9,7.658,23.882,3.725,27.334-12.859L329.873,30.718C334.942,10.409,322.116,1.221,308.864,7.219Z"
          transform="translate(69 113.047)"
          fill="#fff"
        />
      </svg>
    </IconWrapper>
  )
}
